import { NeedDto } from '@act/shared/data-transfer-objects';
import { Alert } from '@act/storybook';
import syvaNeedsUtils from '@act/react-components/needs/syvaNeeds.util';
import { needRequests } from 'redux/requests/need.requests';
import { membersAppSelectors } from 'redux/slices/memberSlice';
import { useApiCall } from 'redux/utils/api-hook';

const NeedTimeAlert = ({
  need,
  showDaysRemaining = true,
}: {
  need: NeedDto;
  showDaysRemaining?: boolean;
}) => {
  const [_payload, _isLoading, patchNeed] = useApiCall(needRequests.patchNeed);
  const member = membersAppSelectors.useSelectMemberById(need.memberId);
  function extendTime() {
    patchNeed({
      body: { shouldExtend: true },
      params: { needId: need?.id },
    });
  }

  const daysRemaining = syvaNeedsUtils.calculateRemainingDays(need.expiresAt);
  const canExtendTime = daysRemaining < 8;
  const needEditable = syvaNeedsUtils.needIsEditable(need, member);

  const remainingDaysDisplay =
    syvaNeedsUtils.formatRemainingDays(daysRemaining);

  if (!needEditable || !!need.fulfilledAt) {
    return null;
  }

  if (canExtendTime) {
    return (
      <Alert
        severity="warning"
        variant="tonal"
        trackingName="need-extend-time-alert"
        action={{
          label: 'Extend time',
          onClick: () => extendTime(),
          debounced: true,
        }}
      >
        {`${remainingDaysDisplay} in time window`}
      </Alert>
    );
  } else {
    if (showDaysRemaining) {
      return (
        <Alert
          severity="info"
          variant="tonal"
          trackingName="need-time-remaining-alert"
        >
          {`${remainingDaysDisplay} in time window`}
        </Alert>
      );
    }
  }
};

export default NeedTimeAlert;
